<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="fs-14px black--text mb-2">Tài sản thuê:</div>
        <v-row dense>
          <v-col cols="6">
            <v-autocomplete
              v-model="order.id_asset"
              class="c-input-small"
              :items="assetOptions"
              dense
              outlined
              hide-details
              label="Loại xe"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="order.rent_day"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="*Số ngày thuê"
              type="number"
              @keypress="allowOnlyPositiveIntegers"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="">
              <v-radio-group
                v-model="order.count_charger"
                hide-details
                dense
                class="c-input-small mt-0 mb-1"
              >
                <v-row dense>
                  <v-col cols="6">
                    <v-radio label="Lấy bộ sạc" :value="1"></v-radio>
                  </v-col>
                  <v-col cols="6">
                    <v-radio label="Không lấy bộ sạc" :value="0"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="order.note"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Ghi chú"
              rows="2"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ORDER_CREATE_DEFAULT_PARTNER_ITEM } from "@/libs/const";

export default {
  name: "PartnerItems",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
    assets: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    order: { ...ORDER_CREATE_DEFAULT_PARTNER_ITEM },
    code: null,
    isLoading: false,
  }),
  computed: {
    assetOptions() {
      return [...this.assets].map((asset) => ({
        text: asset.name,
        value: asset.id,
      }));
    },
    scannedCodes() {
      if (!this.order.items || this.order.items.length === 0) {
        return [];
      }

      return [...this.order.items].map((item) => item.code);
    },
    voucherOptions() {
      if (!this.vouchers || this.vouchers.length === 0) {
        return [];
      }

      return [...this.vouchers].map((voucher) => ({
        text: `${voucher.code} - ${voucher.name}`,
        value: voucher.id,
      }));
    },
  },
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
  },
  created() {
    if (this.info && this.info.id) {
      console.log(this.info);
      console.log("assetOptions", this.assetOptions);
      this.order = {
        ...this.order,
        id_asset: this.info.id_asset,
        rent_day: this.info.rent_day,
        note: this.info.note,
        count_charger: this.info.count_charger,
      };
    } else {
      this.setDefaultAsset();
    }
  },
  methods: {
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_PARTNER_ITEM };
    },
    setDefaultAsset() {
      this.order = {
        ...this.order,
        id_asset:
          this.assetOptions &&
          this.assetOptions[0] &&
          this.assetOptions[0].value,
      };
    },
  },
};
</script>
